import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "changetextcolorchoices"
    }}>{`ChangeTextColorChoices`}</h1>
    <p>{`Changed text color options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHANGE_USES_GALLEY_TEXT_COLOR`}</strong>{` = 1700095843`}</p>
      <p parentName="blockquote">{`The text color for changed text is the same as the galley text color.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHANGE_USES_CHANGE_PREF_COLOR`}</strong>{` = 1700098147`}</p>
      <p parentName="blockquote">{`The text color for changed text is the same as the text color defined in track changes preferences. For information, see text color for added text, text color for deleted text, or text color for moved text.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      